import * as React from "react"

import {Button, MenuItem} from "@blueprintjs/core"
import {ItemRenderer, MultiSelect} from "@blueprintjs/select"
import "./MultiSelect.scss"

const ItemMultiSelect = MultiSelect.ofType<string>()

export interface SelectItemState {
    selected: string
    items: string[]
    name: string
    disabled: boolean
    query: string
}
export interface SelectItemProps {
    selected?: string
    items: string[]
    name: string
    handleSelect: (article: SelectItemState | any) => void
    className?: string
    disabled: boolean
}

export class SingleSelectString extends React.PureComponent<
    SelectItemProps,
    SelectItemState
> {
    constructor(props: any) {
        super(props)
        this.state = {
            selected: this.props.selected || undefined,
            items: this.props.items,
            name: this.props.name,
            disabled: this.props.disabled,
            query: "",
        }
    }

    public static getDerivedStateFromProps(props, state) {
        return {items: props.items, disabled: props.disabled}
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({selected: this.props.selected})
        }
    }

    // NOTE: not using Items.itemRenderer here so we can set icons.
    private renderItem: ItemRenderer<string> = (
        film,
        {modifiers, handleClick}
    ) => {
        if (!modifiers.matchesPredicate) {
            return null
        }
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                className={
                    this.isItemSelected(film) ? "biocrates-selected" : ""
                }
                key={film}
                onClick={handleClick}
                text={`${film}`}
                shouldDismissPopover={false}
            />
        )
    }

    private renderTag = (film: string) => film

    private handleTagRemove = (_tag: React.ReactNode, index: number) => {
        this.deselectItem()
        this.props.handleSelect(this.state)
    }

    private handleItemSelect = (film: string) => {
        if (!this.isItemSelected(film)) {
            this.selectItem(film)
        } else {
            this.deselectItem()
        }
    }

    private handleClear = () =>
        this.setState({selected: undefined}, () =>
            this.props.handleSelect(this.state)
        )

    private deselectItem() {
        this.setState(
            {
                // eslint-disable-next-line react/no-access-state-in-setstate
                selected: undefined,
            },
            () => this.props.handleSelect(this.state)
        )
    }

    private selectItems(selectedToSelect: string) {
        const {selected} = this.state

        this.setState(
            {
                selected: selectedToSelect,
            },
            () => this.props.handleSelect(this.state)
        )
    }

    private selectItem(film: string) {
        this.selectItems(film)
    }

    private isItemSelected(item: string) {
        return this.state.selected === item
    }

    // eslint-disable-next-line class-methods-use-this
    private areItemsEqual(item1: string, item2: string) {
        return item1.toLowerCase() === item2.toLowerCase()
    }

    // eslint-disable-next-line class-methods-use-this
    private stringPredicate(query, item, _index, exactMatch): boolean {
        const normalizedTitle = item.toLowerCase()
        const normalizedQuery = query.toLowerCase()

        if (exactMatch) {
            return normalizedTitle === normalizedQuery
        }
        return normalizedTitle.indexOf(normalizedQuery) >= 0
    }

    public render() {
        const {selected} = this.state

        const clearButton = selected ? (
            <Button icon="cross" minimal onClick={this.handleClear} />
        ) : undefined

        return (
            <div>
                <ItemMultiSelect
                    className={
                        this.state.disabled
                            ? "CardRowElementDisabled"
                            : "CardRowElement"
                    }
                    itemRenderer={this.renderItem}
                    items={this.state.items}
                    noResults={<MenuItem disabled text="No results." />}
                    onItemSelect={this.handleItemSelect}
                    popoverProps={{minimal: false}}
                    tagRenderer={this.renderTag}
                    tagInputProps={{
                        onRemove: this.handleTagRemove,
                        rightElement: clearButton,
                    }}
                    onQueryChange={(query) => this.setState({query})}
                    query={this.state.query}
                    selectedItems={[this.state.selected]}
                    itemsEqual={this.areItemsEqual}
                    itemPredicate={this.stringPredicate}
                />
            </div>
        )
    }
}
